import env from '@config/env';

export function buildYasguiUrl(query: string, tabTitle: string, endpoint: string = env.sparqlEndpoint): string {
  const encodedQuery = encodeURIComponent(query);
  const encodedEndpoint = encodeURIComponent(endpoint);
  const encodedTitle = encodeURIComponent(tabTitle);
  return `/yasgui/#query=${encodedQuery}&endpoint=${encodedEndpoint}&requestMethod=POST&tabTitle=${encodedTitle}&headers=%7B%7D&contentTypeConstruct=text%2Fturtle%2C*%2F*%3Bq%3D0.9&contentTypeSelect=application%2Fsparql-results%2Bjson%2C*%2F*%3Bq%3D0.9&outputFormat=Table`;
}

export function openInYasgui(query: string, tabTitle: string, endpoint?: string): void {
  window.open(buildYasguiUrl(query, tabTitle, endpoint), '_blank', 'noopener,noreferrer');
}
